import { persistKeitaroClickSubid } from "./utils/trackingStorage";

persistKeitaroClickSubid();
